import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito ser diseñador o copywriter?',
  a: 'No. Necesitás criterio para testear y medir. 100ads te entrega volumen y estructura.'
}, {
  q: '¿Esto me garantiza ventas?',
  a: 'No vendo magia. Te da lo que hoy te falta: volumen + ángulos + velocidad. Lo que hagas con eso (testear en serio) define el resultado.'
}, {
  q: '¿Puedo crear videos con esta herramienta?',
  a: 'Por ahora genera imágenes para Meta Ads. Es lo que más impacto tiene en testing de volumen.'
}, {
  q: '¿Sirve para más de un curso/producto digital?',
  a: 'Sí, no tiene límites. Podés usarla para todos tus cursos y productos digitales.'
}, {
  q: '¿Tiene suscripción mensual?',
  a: 'Es una suscripción mensual. Pagás mes a mes y podés cancelar o pausar cuando quieras, sin permanencia ni penalidades.'
}, {
  q: '¿Ya probé Sora/Higgsfield/Canva… por qué esto sería distinto?',
  a: 'Porque esas herramientas te ponen en modo "artesano". 100ads te pone en modo testing: 100 piezas, ahora, para encontrar ganadores rápido.'
}, {
  q: '¿Tiene algún límite de creación?',
  a: 'No. Como conectás tu propia API de Google AI Studio (que es gratuita en su capa estándar), no tenés límites arbitrarios de la plataforma.'
}, {
  q: '¿Hay algún plan gratuito para probar?',
  a: 'No ofrecemos plan free. Ofrecemos algo mejor: Garantía de Funcionamiento 72hs. Si la app presenta errores técnicos que impidan su uso, te devolvemos el 100% del dinero dentro de las primeras 72 horas. Sin vueltas, sin letra chica. ⚠️ Importante: 100Ads NO es para curiosos ni para "probar a ver qué onda". Es para dueños de productos digitales que quieren escalar con volumen real. La garantía cubre errores técnicos de la plataforma, no "no me gustó" o "no lo usé".'
}];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="glass-card rounded-xl overflow-hidden mb-4 transition-all duration-300 hover:bg-white/[0.05]" data-id="element-36">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 px-6 flex items-center justify-between text-left" data-id="element-37">
        <span className="font-bold text-lg md:text-xl pr-8 text-white" data-id="element-38">
          {q}
        </span>
        <span className={`flex-shrink-0 text-purple-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-39">
          {isOpen ? <MinusIcon className="w-6 h-6" data-id="element-40" /> : <PlusIcon className="w-6 h-6" data-id="element-41" />}
        </span>
      </button>
      <AnimatePresence data-id="element-42">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-43">
            <div className="px-6 pb-6 pt-0" data-id="element-44">
              <p className="text-gray-400 leading-relaxed text-base" data-id="element-45">{a}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <section id="faq" className="py-24 bg-[#050505]" data-id="element-46">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-47">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-48">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-2" data-id="element-49">
          {FAQS.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-50" />)}
        </div>
      </div>
    </section>;
}